import { IsoLocale } from "@izettle/constants"

import { DocumentProps } from "./types"

const passportDocument: DocumentProps = {
  purpose: "proofOfIdentity",
  type: "passport",
  title: "PROOF_OF_IDENTITY_DOCUMENT_TYPE_PASSPORT",
}

const nationalIdDocument: DocumentProps = {
  purpose: "proofOfIdentity",
  type: "nationalId",
  doubleSided: true,
  title: "PROOF_OF_IDENTITY_DOCUMENT_TYPE_NATIONAL_ID",
  description: "front",
}

const drivingLicenseDocument: DocumentProps = {
  purpose: "proofOfIdentity",
  type: "drivingLicense",
  title: "PROOF_OF_IDENTITY_DOCUMENT_TYPE_DRIVERS_LICENSE",
}

const residenceIdDocument: DocumentProps = {
  purpose: "proofOfIdentity",
  type: "residenceId",
  doubleSided: true,
  title: "PROOF_OF_IDENTITY_DOCUMENT_TYPE_RESIDENCE_ID",
  description: "front",
}

export const defaultDocuments: DocumentProps[] = [
  passportDocument,
  nationalIdDocument,
  drivingLicenseDocument,
]

export const documentsByMarket: Map<IsoLocale, DocumentProps[]> = new Map([
  [IsoLocale.enGB, defaultDocuments],
  [IsoLocale.deDE, defaultDocuments],
  [
    IsoLocale.frFR,
    [
      passportDocument,
      nationalIdDocument,
      {
        ...drivingLicenseDocument,
        title: "PROOF_OF_IDENTITY_DOCUMENT_TYPE_DRIVERS_LICENSE_FRANCE",
      },
    ],
  ],
  [IsoLocale.nlNL, defaultDocuments],
  [IsoLocale.svSE, defaultDocuments],
  [IsoLocale.nbNO, defaultDocuments],
  [IsoLocale.daDK, [passportDocument, nationalIdDocument]],
  [IsoLocale.fiFI, defaultDocuments],
  [IsoLocale.svFI, defaultDocuments],
  [IsoLocale.esES, defaultDocuments],
  [IsoLocale.itIT, defaultDocuments],
  [IsoLocale.esMX, [nationalIdDocument, passportDocument, residenceIdDocument]],
])
